module.exports = __webpack_public_path__ + "img/Bodice-Back-Ja-Kf-La.5323d17f.png";